module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-86.7b2bd6be.svg";